export default "__VITE_ASSET__CaHo_6HK__"